import React, { Component } from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Row} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import {Button,InputGroup, Form,Dropdown,Container} from "react-bootstrap";
import "../../../node_modules/video-react/dist/video-react.css";

import { Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css'

import styled from 'styled-components';
import {
  Player,
  ControlBar,
  ReplayControl,
  ForwardControl,
  CurrentTimeDisplay,
  TimeDivider,
  PlaybackRateMenuButton,
  VolumeMenuButton
} from 'video-react';


//action
import { setTableData} from "../../actions/transOperationActions";
import 'rc-slider/assets/index.css';
import {set_current_index} from "../../actions/frameActions";
import { update_videoCurrentTime, set_video_duration} from "../../actions/viewOperationActions";


/**影片參數*/
// "currentSrc": "https://d2z15518v804ps.cloudfront.net/watermarked-timeout/2019/2019-04/2019-04-30/546433.wIP7vh0ULmTi3sFv2Z57.19f1384aeb609e00c04965e6c5035991.mp4?imediatrans=1562477137",
//     "duration": 1397.522,
//     "currentTime": 131.173199,
//     "seekingTime": 0,
//     "buffered": {},
// "waiting": false,
//     "seeking": false,
//     "paused": true,
//     "autoPaused": false,
//     "ended": false,
//     "playbackRate": 1,
//     "muted": false,
//     "volume": 1,
//     "readyState": 4,
//     "networkState": 1,
//     "videoWidth": 427,
//     "videoHeight": 240,
//     "hasStarted": true,
//     "userActivity": true,
//     "isActive": false,
//     "isFullscreen": false,
//     "activeTextTrack": null,
//     "error": null,
//     "src": "",
//     "srcObject": null,
//     "crossOrigin": null,
//     "preload": "auto",
//     "defaultPlaybackRate": 1,
//     "played": {},
// "seekable": {},
// "autoplay": false,
//     "loop": false,
//     "controls": false,
//     "defaultMuted": false,
//     "textTracks": {},
// "width": 0,
//     "height": 0,
//     "poster": ""
class TopControl extends Component {

  constructor(props) {
    super(props);

    this.videoCurrentTime_byDrag = 0; //拖拉而來的秒數

    this.videoCurrentTime = 0; //當前秒數　
    this.Last_videoCurrentTime = 0; //最後更新字幕的秒數時間

    this.currentDataIndex = 0;

    //工具
    this.videoFps = 0;
    this.findFrameSplitValue = 0;


    this.state = {

      //影片顯示寬度
      viewWidth:this.props.viewOperation.viewWidth,
      viewHeight:this.props.viewOperation.viewHeight,


      sliderValue: null,
      source: this.props.src,

      ifShowPlayIcon:false,

      isManualSeek:false,
      forwardSeconds:5,
      // currentDataIndex:0,
      currentCellSelect:0,



    };

    this.changeCurrentTime = this.changeCurrentTime.bind(this);
    this.seek = this.seek.bind(this);
    this.changePlaybackRateRate = this.changePlaybackRateRate.bind(this);
    this.changeVolume = this.changeVolume.bind(this);
    this.dragSetCurrentTime = this.dragSetCurrentTime.bind(this);
  }



 　async dragSetCurrentTime(videoCurrentTime){
    this.player.seek(videoCurrentTime);
    this.videoCurrentTime = videoCurrentTime;
  }

  // reset = () => {
  //   this.setState({ sliderValue: null });
  // };

  componentWillReceiveProps(nextProps) {

    const {videoFps} = this.props.transOperation;
    this.videoFps = videoFps;

    if(parseFloat(nextProps.context.findFrameSplitValue) !== parseFloat(this.state.findFrameSplitValue)  ){
      this.findFrameSplitValue = nextProps.context.findFrameSplitValue;
    }

    if(parseFloat(nextProps.viewOperation.viewWidth) !== parseFloat(this.state.viewWidth)  ){

      //影片顯示寬度
      this.setState({
        viewWidth: nextProps.viewOperation.viewWidth,
        viewHeight:nextProps.viewOperation.viewHeight});
    }
  }
  componentDidMount() {
    this.videoFps = this.props.transOperation.videoFps;　
    this.findFrameSplitValue = this.props.context.findFrameSplitValue;


    //設定欄位資料
    document.getElementById('findFrameSplitValue').value = this.findFrameSplitValue;

  }

  changeCurrentTime(seconds) {
    return () => {
      const { player } = this.player.getState();
      //this.player.seek(player.currentTime + seconds);

      //更新上方
      // this.props.updupdate_videoCurrentTimeate_videoCurrentTime(player.currentTime);

    };
  }

  seek(seconds) {
    return () => {
      //this.player.seek(seconds);
    };
  }

  changePlaybackRateRate(steps) {
    return () => {
      const { player } = this.player.getState();
      //this.player.playbackRate = steps;
    };
  }

  changeVolume(steps) {
    return () => {
      const { player } = this.player.getState();
      //this.player.volume = player.volume + steps;
    };
  }

  render() {
    const { videoFps } = this.props.transOperation;

    const {ifShowPlayIcon,sliderValue,forwardSeconds,viewHeight ,data} = this.state;

    //啟動 暫停
    let playButtonView;
    if(ifShowPlayIcon === false){
      playButtonView = <Icon onClick={this.play} name='play' />;
    }else{
      playButtonView = <Icon onClick={this.pause} name='pause' /> ;
    }


    const TopWrapObj = styled.div`     
    float: left; 
  　width: ${props => props.width}px;　
  `;

    let ccClassName = 'primary';
    if(this.state.ccEnable === false){
      ccClassName = 'secondary'
    }

    return (
        <div className=" col-12 small m-0 p-0" style={{
          height: '40px'}}>
          <TopWrapObj
              style={{
                marginTop:"5px"}}
              width={65} >
            <span id="fpsButton" className="fpsButton" data-value={{videoFps}} >{videoFps}FPS</span>
          </TopWrapObj>

          {/*<TopWrapObj*/}
          {/*    width={34} >*/}
          {/*  <Button className="ml-1" variant={ccClassName} size="sm" onClick={ async ( ) => {*/}
          {/*    await this.setState({ ccEnable: !this.state.ccEnable })*/}
          {/*  }}>cc</Button>*/}
          {/*</TopWrapObj>*/}


          {/*<TopWrapObj*/}
          {/*    width={40} >*/}
          {/*  <Icon className={"mr-2"} name='arrow up' size='small'*/}
          {/*        onClick={  ()=>{*/}

          {/*          let newIndex = TimeUtils.secondsConvertToRowIndew(this.videoCurrentTime,this.videoFps,data[this.currentDataIndex]);*/}

          {/*          this.props.context.setway(1);*/}
          {/*        }} />*/}

          {/*  <Icon className={"mr-2"} name='arrow down' size='small'*/}
          {/*        onClick={  ()=>{*/}
          {/*          let newIndex = TimeUtils.secondsConvertToRowIndew(this.videoCurrentTime,this.videoFps,data[this.currentDataIndex]);*/}
          {/*          this.props.arrowUpOrDown(0,newIndex);*/}
          {/*          this.props.context.setway(0);*/}
          {/*        }} />*/}
          {/*</TopWrapObj>*/}


          <TopWrapObj
              width={65} >

            <Dropdown  className=" ">
              <Dropdown.Toggle className="w-100 text-left"  id="dropdown-basic"
                               style={{
                                 backgroundColor:"white",
                                 color:"gray",
                                 border:"1px solid lightgray"
                               }} >
                <Icon  name='music' size='small' />
              </Dropdown.Toggle>

              <Dropdown.Menu >
                <Dropdown.Item  onClick={()=>{
                  // this.props.insertSymblo(" ♪ ");
                  this.props._WaveformView.decorativeMusic();
                }}>
                  ♪
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo(" ® ");
                }}>
                  ®
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo(" ° ");
                }}>
                  °
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo(" ½ ");
                }}>
                  ½
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo(" ™ ");
                }}>
                  ™
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo(" — ");
                }}>
                  —
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo(" « ");
                }}>
                  «
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo("»");
                }}>
                  »
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo("„");
                }}>
                  „
                </Dropdown.Item>
                <Dropdown.Item  onClick={()=>{
                  this.props.insertSymblo("…");
                }}>
                  …
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </TopWrapObj>

          <TopWrapObj
              width={115} >

            <Form.Group >
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm" style={{fontSize:'8pt'}}>
                  FF/FB (Sec):
                </InputGroup.Text>
                <Form.Control style={{width:'30px'}} size="sm" type="text" placeholder='forwardSeconds'
                              value={this.state.forwardSeconds}
                              onChange={  (event) => {
                                this.setState({ forwardSeconds: parseInt(event.target.value) });

                                if(isNaN(event.target.value) === true){

                                }else{
                                  if(event.target.value !== ""){
                                    //往上更新數值
                                    this.props.updateforwardSeconds(parseFloat(event.target.value));
                                  }
                                }

                              }}
                />
              </InputGroup.Prepend>
            </Form.Group>
          </TopWrapObj>

          <TopWrapObj
              width={115} >
            <Form.Group >
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm"  style={{fontSize:'8pt'}}>
                  Frame Edit:
                </InputGroup.Text>
                <Form.Control id="findFrameSplitValue" style={{width:'30px'}} size="sm" type="text" placeholder=''
                              value={this.findFrameSplitValue}
                              onChange={   (event) => {

                                if(isNaN(event.target.value) === true){

                                }else{
                                  if(event.target.value !== ""){
                                    //往上更新數值
                                    this.props.context.setfindFrameSplitValue(parseInt(event.target.value));
                                    //更新編輯頁的數值
                                    this.props.updatefindFrameSplitValue(parseFloat(event.target.value))
                                  }
                                }

                                //setFrameSplitValue
                                this.findFrameSplitValue = event.target.value;
                                document.getElementById('findFrameSplitValue').value = this.findFrameSplitValue;
                              }}
                />
              </InputGroup.Prepend>
            </Form.Group>
          </TopWrapObj>
        </div>
    );
  }
}

TopControl.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
  videoPlayer: state.videoPlayer,
  viewOperation: state.viewOperation,
  editTable: state.editTable,
  frameControl: state.frameControl,
});

export default connect(mapStateToProps, {
  set_video_duration,
  update_videoCurrentTime,
  set_current_index,
  setTableData
})(
    withRouter(TopControl)
);



// WEBPACK FOOTER //
// ./src/components/video/TopControl.js